/**
 * @function Text
 * @param {Object} props The properties passed to the component.
 * @param {Object} props.sanity The sanity data object containing the title and description of the text content.
 * @param {string} props.sanity.title The title of the text block.
 * @param {Array} props.sanity.description An array of blocks containing text description, keys, and type information.
 * @returns {JSX.Element} A React component that renders a text block with a given title and description.
 * @description This component takes in a `sanity` object with a title and description and renders a text block inside a container. The description is processed as a series of blocks, and PortableText is used to display the content of each block.
 * @example
 * const sanity = {
 *   title: "Page Title",
 *   description: [
 *     { _key: "key1", _type: "block", children: [{ text: "Description text" }] }
 *   ]
 * };
 * 
 * <Text sanity={sanity} />
 * // Renders a div with title "Page Title" and a PortableText component displaying "Description text".
 */
import {PortableText} from '@portabletext/react';
export default function Text({sanity}) {
  return (
    <div className="w-full mx-auto py-10 px-4">
      <div className="w-full">
        <div className="md:container md:mx-auto xs:px-5">
          <div className="px-5 xs:px-6">
            <h1 className="page-title">{sanity.title}</h1>
          </div>
          <div className="md:p-5 xs:p-2 librero-page">
            {sanity?.description &&
              sanity.description.map((block) => {
                return (
                  <div key={block._key}>
                    {block._type !== 'block' || !block.children ? (
                      ''
                    ) : (
                      <PortableText value={block} />
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </div>
  );
}
